import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-gray-1 rounded p-6 md:p-0 md:py-3" }
const _hoisted_2 = { class: "flex flex-row w-full" }
const _hoisted_3 = { class: "block w-20" }
const _hoisted_4 = { class: "flex flex-row flex-1 justify-between items-center" }
const _hoisted_5 = { class: "flex w-1/5" }
const _hoisted_6 = { class: "flex w-1/5" }
const _hoisted_7 = { class: "flex w-1/5" }
const _hoisted_8 = { class: "flex w-1/5" }
const _hoisted_9 = { class: "flex w-1/5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-orders mr-2" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row w-full border-t-2 border-gray-4 mt-6 pt-6 text-light"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-20" }, null, -1)
const _hoisted_13 = { class: "flex flex-row flex-1" }
const _hoisted_14 = { class: "w-1/2" }
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { class: "mb-1" }
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = { class: "mb-1" }
const _hoisted_20 = { class: "font-semibold" }
const _hoisted_21 = { class: "flex flex-col w-1/2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row w-full mb-1 font-semibold" }, "Address:", -1)
const _hoisted_23 = { class: "flex flex-row w-full items-center" }
const _hoisted_24 = { class: "w-1/2" }
const _hoisted_25 = { class: "mb-1" }
const _hoisted_26 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_27 = { class: "w-1/2" }
const _hoisted_28 = { class: "mb-1" }
const _hoisted_29 = { class: "mb-1" }
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_expand_button = _resolveComponent("expand-button")!
  const _component_default_button = _resolveComponent("default-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_expand_button, {
          class: "relative top-3 mx-auto",
          modelValue: _ctx.isExpanded,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isExpanded) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.subcustomer?.company_name || "-"), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.subcustomer?.id || "-"), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.subcustomer?.main_address?.city || "-"), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.subcustomer?.country || "-"), 1),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_default_button, {
            class: "w-full",
            type: "outline",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSubcustomerParcels(_ctx.subcustomer?.id)))
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("account.subcustomers.parcels")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("account.subcustomers.client_id")) + ": ", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.subcustomer?.id), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("account.subcustomers.registration_number")) + ": ", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.subcustomer?.registration_number), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("account.subcustomers.tax_id")) + ": ", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.subcustomer?.tax_id), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.subcustomer?.main_address?.address_first_line || "-"), 1),
                  (_ctx.subcustomer?.main_address?.address_second_line)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.subcustomer?.main_address?.address_second_line), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.subcustomer?.main_address?.city || "-"), 1),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.subcustomer?.main_address?.zip_code || "-"), 1),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.subcustomer?.country || "-"), 1)
                ])
              ])
            ])
          ]),
          _hoisted_31
        ]))
      : _createCommentVNode("", true)
  ]))
}